<div class="container-fluid">
  <div class="row" *ngIf="(this.playlists | json)!== ({}|json) else this.loadingContentTemplate">

    <div class="workbook">
      <div class="workbook-around dakkini-card">
        <h2>Workbook</h2>
        <p i18n>Este es un libro de trabajo que te ofrecemos como una herramienta o un mapa de ruta que te recuerde las
          distintas áreas de oportunidad para una jornada integral de sanación, crecimiento, autodescubrimiento y
          reconexión con tu ser y tu potencial pleno.
        </p>
        <a [routerLink]="['/platform/workbook/.']" class="btn btn-primary" style="height: auto;" i18n>Ir al workbook</a>
      </div>
    </div>

    <div *ngIf="this.categoryId else noCategory ">
      <section class="Playlists__container">
        <div class="Playlist__title">
          <h1><span>{{playlists.title}}</span></h1>
        </div>
        <div class="Playlist">
          <div class="Playlist__Videos"
            *ngFor="let video of $any(!this.categoryId ? (playlists.resources | slice:0:11) : (playlists.resources)); let last = last">
            <div class="a_video">
              <a [routerLink]="['/platform/library',playlists.id,'play', video.id,'.']">
                <img [src]="locale == 'en' && video.thumb_en ? video.thumb_en : video.thumb" [alt]="video.title+'- video'" class="img-fluid">
              </a>
              <a [routerLink]="['/platform/library',playlists.id,'play', video.id,'.']" class="Playlist__Videos--title">
                {{video.title}}
              </a>
            </div>
          </div>
          <div [routerLink]="playlists.id+'/.'" *ngIf="playlists.resources.length>11 && !this.categoryId"
            class="Playlist__Videos" style="cursor:pointer;">
            <div class="view__more">
              <div class="plus__circle">
                +
              </div>
              <div>
                <p i18n>Ver Más</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="Playlists__container">
      <div class="Playlist__User">
        <div class="Playlist__User--avatar">
          <img src="assets/images/melanie.jpg" alt="" />
        </div>
        <div class="Playlist__User--name">
          <h1>Melanie Shank</h1>
          <p i18n>Originaria de Texas, USA, Melanie Shank es practicante de yoga desde el año 2000. Realizó su primera
            formación como profesora de Hatha Yoga en 2004 y desde entonces ha continuado sus estudios y formaciones
            en diferentes linajes y caminos de sabiduría. Con compromiso y alegría comparte clases, talleres,
            capacitaciones y retiros de una manera accesible y auténtica, para todos los niveles.</p>
          <p i18n>Desde 2009, Melanie ha estudiado directamente con la yogini Uma Parvathi Nanda Nath, quien le
            transmitió
            las enseñanzas de Kaula Hatha Yoga que han transformado profundamente su práctica personal y su enseñanza.
            Su intención al compartir el Yoga es ofrecer un espacio sagrado y contenido para la autoexploración de las
            capas sutiles del cuerpo, la mente y el corazón, para crear un espacio para el verdadero reconocimiento y
            la experiencia de la unidad aquí en el cuerpo, y para transmitir con humildad y honor las hermosas y
            poderosas prácticas y técnicas de este auténtico linaje de Kaula Hatha Yoga.</p>
          <p i18n>Ha tenido una vasta experiencia de más de 30 años con psicodélicos como parte de su exploración de la
            conciencia.</p>
          <p i18n>Ha experimentado los protocolos {{this.companyName}} de microdosis en sí misma y ha acompañado varias
            personas en
            el
            tratamiento porque conoce bien el proceso.</p>
          <p i18n>Considera que a veces se necesitan herramientas para manejar las emociones que emergen y para traer
            más
            conciencia al proceso de sanación e integración.</p>
          <p i18n>Por eso propone algunas técnicas de meditación, respiración y posturas de yoga para apoyar en el
            proceso
            de transformación; para que los cambios de patrones y hábitos sean más completos y estables.</p>
        </div>
      </div>
    </div>

    <ng-template #noCategory>

      <div class="Playlists__container" *ngFor="let playlist of this.playlists">
        <div class="Playlist__title">
          <a [routerLink]="'/platform/library/'+playlist.id+'/.'">
            <h1><span>{{this.locale==='en' && playlist.title_en ? playlist.title_en : playlist.title}}</span></h1>
          </a>
        </div>
        <div class="Playlist">
          <div class="Playlist__Videos"
            *ngFor="let video of $any(!this.categoryId ? (playlist.resources | slice:0:11) : (playlist.resources)); let last = last">
            <div class="">
              <a [routerLink]="['/platform/library',playlist.id,'play', video.id,'.']">
                <img [src]="locale ==='en' && video.thumb_en ? video.thumb_en : video.thumb" [alt]="video.title+'- video'" class="img-fluid">
              </a>
              <a [routerLink]="['/platform/library',playlist.id,'play', video.id,'.']" class="Playlist__Videos--title">
                {{this.locale==='en' && video.title_en ? video.title_en : video.title}}
              </a>
            </div>
          </div>
          <div [routerLink]="playlist.id+'.'" *ngIf="playlist.resources.length>11 && !this.categoryId"
            class="Playlist__Videos" style="cursor:pointer;">
            <div class="view__more">
              <div class="plus__circle">
                +
              </div>
              <div>
                <a [routerLink]="'/platform/library/'+playlist.id+'.'" i18n>Ver Más</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

  </div>
</div>

<ng-template #loadingContentTemplate>
  <loading-dots-component></loading-dots-component>
</ng-template>